<template>
  <main>
    <div class="row">
      <div class="col-12">
        <b-tabs v-model="filterFormModel.status" @input="load">
          <b-tab>
            <template #title>
              {{ $t('all') }}
              <small v-if="!countLoading">({{ count[0] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab>
            <template #title>
              {{ $t('vat') }}
              <small v-if="!countLoading">({{ count[1] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab>
            <template #title>
              {{ $t('customer') }}
              <small v-if="!countLoading">({{ count[2] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
          <b-tab>
            <template #title>
              {{ $t('manualInvoice') }}
              <small v-if="!countLoading">({{ count[3] }})</small>
              <b-spinner v-if="countLoading" class="ml-1" small variant="primary"></b-spinner>
            </template>
          </b-tab>
        </b-tabs>
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-2" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                          :placeholder="$t('enterKeyword')"/>
            <form-select class="mr-1 mb-2" :model="filterFormModel" attribute="clientStatus"
                         :options="clientStatusOptions"/>
            <client-select :model="filterFormModel" attribute="client"
                           :isFilter="true" :place-holder="$t('selectClient')" class="mr-1 mb-2"/>
            <time-range-picker :model="filterFormModel" :label="$t('invoiceStartTime')" class="mr-1 mb-2"/>
            <button @click="load" class="btn btn-primary mr-1 mb-2">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-2">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-sorting">
          <div class="row">
            <div class="col c-sorting__right">
              <div class="c-sorting__btn">
                <invoice-export v-if="['owner', 'admin', 'accountant'].includes($store.state.user.role)"
                                :filter="filterFormModel" :total-count="itemCount"/>
                <import></import>
              </div>
            </div>
          </div>
        </div>
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-3">{{ $t('client') }}</div>
            <div class="col-lg-2">{{ $t('status') }}</div>
            <div class="col-lg-5">{{ $t('invoiceInfo') }}</div>
            <div class="col-lg-2"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-3">
              <div>
                <b>{{ $t('clientCode') }}: </b>
                <span v-if="item.code">{{ item.code }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
              <div>
                <b>{{ $t('companyName') }}: </b>
                <span v-if="item.companyName">{{ item.companyName }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
              <div>
                <b>Domain: </b>
                <span v-if="item.domain">{{ item.domain }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
            </div>
            <div class="col-lg-2">
              <div>
                <span v-if="item.manualInvoiceEnabled" class="badge badge-danger">{{
                    $t('manualInvoice')
                  }}</span>
                <span v-else-if="item.invoiceEnabled" class="badge badge-success">{{ $t('vat') }}</span>
                <span v-else class="badge badge-warning">{{ $t('customer') }}</span>
              </div>
            </div>
            <div class="col-lg-5">
              <div>
                <b>{{ $t('invoiceCustomerName') }}: </b>
                <span v-if="item.invoiceCustomerName">{{ item.invoiceCustomerName }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
              <!--              <div>-->
              <!--                <b>{{ $t('invoiceCompanyName') }}: </b>-->
              <!--                <span v-if="item.invoiceCompanyName">{{ item.invoiceCompanyName }}</span>-->
              <!--                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>-->
              <!--              </div>-->
              <div>
                <b>{{ $t('invoiceTaxCode') }}: </b>
                <span v-if="item.invoiceTaxCode">{{ item.invoiceTaxCode }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
              <div>
                <b>{{ $t('invoiceIdentity') }}: </b>
                <span v-if="item.invoiceIdentity">{{ item.invoiceIdentity }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
              <div>
                <b>{{ $t('invoiceAddress') }}: </b>
                <span v-if="item.invoiceAddress">{{ item.invoiceAddress }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
              <div>
                <b>{{ $t('invoiceEmail') }}: </b>
                <span v-if="item.invoiceEmail">{{ item.invoiceEmail.replace(/;/g, ', ') }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
              <div>
                <b>{{ $t('invoiceStartTime') }}: </b>
                <span v-if="item.invoiceStartTime">{{ item.invoiceStartTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
            </div>
            <div class="col-lg-2">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2">
                  <button v-if="['owner', 'accountant', 'tech'].includes($store.state.user.role)"
                          @click="update(item._id)"
                          type="button" class="btn btn-sm btn-info mr-1">
                    <font-awesome-icon icon="edit"/>&nbsp;{{ $t('edit') }}
                  </button>
                  <button type="button" class="btn btn-sm btn-info mr-1" @click="openCreditDepositModal(item)">
                    <font-awesome-icon icon="list"/>
                    {{ $t('creditList') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword || filterFormModel.from && filterFormModel.to">{{
            $t('notFoundSearch')
          }}</span>
        <span v-else>{{ $t('notFound') }}</span>
      </div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
    <b-modal v-model="showForm" :title="formTitle" @ok="save" no-close-on-backdrop no-enforce-focus>
      <form-checkbox :chk-label="$t('vat')" :model="formModel" attribute="invoiceEnabled" :errors="formErrors"/>
      <form-input :label="$t('invoiceCustomerName')" :model="formModel" :errors="formErrors"
                  attribute="invoiceCustomerName"/>
      <!--      <form-input :label="$t('invoiceCompanyName')" :model="formModel" :errors="formErrors"-->
      <!--                  attribute="invoiceCompanyName"/>-->
      <div v-if="taxCodeWarning" class="alert alert-warning py-1 px-2 small">{{ taxCodeWarning }}</div>
      <form-input :label="$t('invoiceTaxCode')" :model="formModel" :errors="formErrors"
                  attribute="invoiceTaxCode" @change="searchInvoiceCode"/>
      <form-input :label="$t('invoiceIdentity')" :model="formModel" :errors="formErrors"
                  attribute="invoiceIdentity"/>
      <form-input :label="$t('invoiceAddress')" :model="formModel" :errors="formErrors"
                  attribute="invoiceAddress"/>
      <form-array :label="$t('invoiceEmail')" :model="formModel" :errors="formErrors" attribute="invoiceEmailArray"/>
      <form-date-time :label="$t('invoiceStartTime')" :model="formModel" :errors="formErrors"
                      attribute="invoiceStartTime" format="DD/MM/YYYY HH:mm:ss"></form-date-time>
    </b-modal>
    <b-modal size="xl" v-model="showCreditDepositModal" :title="$t('creditList')" no-enforce-focus>
      <credit-deposit-list-modal :client="clientInvoice" :tab="4"></credit-deposit-list-modal>
      <template v-slot:modal-footer>
        <b-button variant="secondary" class="float-right" @click="closeCreditDepositModal">{{ $t('cancel') }}</b-button>
      </template>
    </b-modal>
  </main>
</template>

<script>
import List from "@/mixins/List";
import CRUD from "@/mixins/CRUD";
import TaxCodeLookup from "@/mixins/TaxCodeLookup";
import ClientSelect from "@/components/ClientSelect.vue";
import TimeRangePicker from "@/components/TimeRangePicker.vue";
import Import from "@/views/client/invoice-info/InvoiceImport.vue";
import CreditDepositListModal from "@/views/finance/credit-deposit/CreditDepositListModal.vue";
import InvoiceExport from "@/views/client/invoice-info/InvoiceExport.vue";

export default {
  components: {InvoiceExport, Import, TimeRangePicker, ClientSelect, CreditDepositListModal},
  mixins: [List, CRUD, TaxCodeLookup],
  data: function () {
    return {
      autoLoad: true,
      taxCodeWarning: null,
      service: '/invoice-info',
      reloadBus: 'reloadInvoiceInfo',
      defaultFilterFormModel: {
        status: null,
        client: this.client ? this.client._id : null,
        sales: this.$store.state.user.role === 'sales' ? this.$store.state.user._id : null,
        keyword: null,
        clientStatus: 'active',
      },
      showCreditDepositModal: false,
      clientInvoice: null,
      count: {},
      countLoading: false,
      afterLoad: () => {
        this.getCount();
      },
      clientStatusOptions: [
        {value: null, text: this.$t('all')},
        {value: 'active', text: this.$t('active')},
        {value: 'isTrial', text: this.$t('isTrial')},
        {value: 'expired', text: this.$t('expired')},
      ]
    }
  },
  methods: {
    async searchInvoiceCode() {
      this.taxCodeWarning = null;
      if (!this.formModel.invoiceTaxCode || !this.formModel.invoiceTaxCode.trim()) {
        return;
      }
      const result = await this.lookupTaxCode(this.formModel.invoiceTaxCode);
      if (!result.ok) {
        this.taxCodeWarning = result.message;
        return;
      }
      if (!this.formModel.invoiceAddress && result.data.address) {
        this.$set(this.formModel, 'invoiceAddress', result.data.address);
      }
      this.taxCodeWarning = this.taxStatusWarning(result.data);
    },
    openCreditDepositModal: function (item) {
      this.clientInvoice = item;
      this.showCreditDepositModal = true;
    },
    closeCreditDepositModal: function () {
      this.clientInvoice = null;
      this.showCreditDepositModal = false;
    },
    getCount() {
      this.countLoading = true;
      this.$service.get(this.service + '/count', {params: this.filterFormModel})
          .then(response => {
            this.count = response.data;
          })
          .catch(() => {
            this.count = {};
          })
          .finally(() => {
            this.countLoading = false;
          });
    },
  },
  mounted() {
    this.$bus.$on('reloadInvoiceInfo', this.load);
  },
  beforeDestroy() {
    this.$bus.$off('reloadInvoiceInfo')
  },
  i18n: {
    messages: {
      en: {
        invoiceInfo: "Invoice Info",
        client: "Client",
        info: "Info",
        status: "Status",
        companyName: "Company name",
        phoneNumber: "Phone Number",
        invoiceCompanyName: "Invoice Company Name",
        invoiceTaxCode: "Invoice Tax Code",
        invoiceIdentity: "Invoice Identity",
        invoiceAddress: "Invoice Address",
        invoiceEmail: "Invoice Email",
        invoiceStartTime: "Invoice Start Time",
        vat: "VAT",
        customer: "Customer",
        enterKeyword: "Enter keyword",
        edit: "Edit",
        creditList: "Credit List",
        notFound: "Not found any result!",
        clientCode: "Client Code",
        manualInvoice: "Manual Invoice",
        invoiceCustomerName: "Invoice Customer Name",
        active: "Active",
        isTrial: "Is Trial",
        expired: "Expired",
      },
      vi: {
        invoiceInfo: "Thông tin xuất hóa đơn",
        client: "Khách hàng",
        info: "Thông tin",
        status: "Trạng thái",
        companyName: "Tên công ty",
        phoneNumber: "Số điện thoại",
        invoiceCompanyName: "Tên đơn vị",
        invoiceTaxCode: "Mã số thuế",
        invoiceIdentity: "Số CCCD",
        invoiceAddress: "Địa chỉ",
        invoiceEmail: "Email nhận hóa đơn",
        invoiceStartTime: "Thời gian bắt đầu xuất hóa đơn",
        vat: "Xuất hóa đơn VAT",
        customer: "Khách lẻ",
        enterKeyword: "Từ khóa...",
        edit: "Sửa",
        creditList: "Danh sách lệnh nạp tiền",
        notFound: "Không tìm thấy kết quả nào!",
        clientCode: "Mã khách hàng",
        manualInvoice: "Xuất hóa đơn thủ công",
        invoiceCustomerName: "Tên người mua hàng",
        active: "Đang hoạt động",
        isTrial: "Đang dùng thử",
        expired: "Hết hạn"
      }
    }
  }
}
</script>